export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7ff016742be73b2c2a13edb26e720028baf2ac8ea9&name=fetchTypeahead!'